export enum Statuses {
    CREATED = '96734036-9d31-4b7a-a7f7-9cd26563d3f8',
    APPROVED = '8c9e3bd0-242f-4a57-9164-e0457366552f',
    DELIVERED_TO_PROVIDER = '6c04e009-5c25-4897-886c-4cd9a54b09ce',
    REFUSED = '53876c49-249b-48a8-862e-645aeaa82b2b',
    ACCEPTED = 'bf7e740e-4378-4f96-b958-d6b2bd7edf56',
    DENIED = '674162bd-45be-4037-b6bb-954a1bd90828',
    FINALIZED = '4efad161-af6e-4d43-969c-08ee978f0647'
  }

